import { useCallback, useRef, useEffect } from 'react';
import { useLocalStorage } from 'react-use';

interface CampaignPulseState {
  visitCount: number;
  hasClicked: boolean;
}

const MAX_VISITS_WITH_PULSE = 2;
const STORAGE_KEY = 'arcsite_collect_payment_pulse';
const initialState = {
  visitCount: 0,
  hasClicked: false,
};

export const useCampaignPulse = () => {
  const [pulseState, setPulseState] = useLocalStorage<CampaignPulseState>(
    STORAGE_KEY,
    initialState
  );

  // Why use ref?
  // https://github.com/streamich/react-use/issues/1379
  const pulseStateRef = useRef(pulseState);
  useEffect(() => {
    pulseStateRef.current = pulseState;
  }, [pulseState]);

  const shouldShowPulse =
    pulseState &&
    pulseState.visitCount <= MAX_VISITS_WITH_PULSE &&
    !pulseState.hasClicked;

  const handleCampaignClick = useCallback(() => {
    setPulseState(() => {
      const currentState = pulseStateRef.current || initialState;

      return {
        ...currentState,
        hasClicked: true,
      };
    });
  }, [setPulseState]);

  const handleVisit = useCallback(() => {
    setPulseState(() => {
      const currentState = pulseStateRef.current || initialState;
      return {
        ...currentState,
        visitCount: currentState.visitCount + 1,
      };
    });
  }, [setPulseState]);

  return {
    shouldShowPulse: shouldShowPulse || false,
    handleCampaignClick,
    handleVisit,
  };
};
